module.exports = __webpack_public_path__ + "static/media/portfo-min.068406a2.png";